import React, { useEffect, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import moment from "moment";

// Assets
import "~/assets/sass/pages/invest/evaluteDetail.scss";
import { RoundArrowIcon } from "~/assets/svg/InterfaceIcon";

// Pages
import Return from "~/pages/investment/InvestEvalPage/detail/Step/return";
import Judge from "~/pages/investment/InvestEvalPage/detail/Step/judge-bak";
import Complete from "~/pages/investment/InvestEvalPage/detail/Step/complete";
import currentStatus from "../util/utilForDetail";
import { Case, If } from "~/common/components/If";
import RequestClosed from "./components/RequestClosed";
import RequestOpened from "./components/RequestOpened";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import { useNavigate, useParams } from "react-router";
import EvalItemCheck from "./modal/EvalItemCheck";
import AlertDetail from "./AlertDetail";

import { useGlobalStore } from "~/store";
import { getTitle } from "~/utils/getTitle";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const EvaluateDetailPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [evaluateCategoryModal, setEvaluateCategoryModal] = useState(false);
	const [currentStep, setCurrentStep] = useState("closed");
	const [moveCard, setMoveCard] = useState("step2");
	const [detailData, setDetailData] = useState("");
	const [curStatus, setCurStatus] = useState("");

	const [commentaryModal, setCommentaryModal] = useState(false);
	const [onlineIrModal, setOnlineIrModal] = useState(false);
	const [resultAnnounceModal, setResultAnnounceModal] = useState(false);
	const [resultAnnounceChkAlert, setResultAnnounceChkAlert] = useState(false);
	const [resultAnnounceAlert, setResultAnnounceAlert] = useState(false);
	const [noResultAnnounceAlert, setNoResultAnnounceAlert] = useState(false);
	const detailRequest = useRequest("get", "/vc/invest/detail");

	const param = useParams();
	const [
		{
			user: { company },
		},
	] = useGlobalStore();

	// 평가되는 총 Category 수 와 평가가 진행된 Categories 수.
	// 아래 1/2 이렇게 표현될 것이다.
	// detailData 에 Judge 배열에 status 가 "완료" 인것들 = evaluatedNum
	// detailData 에 Judge 배열의 총 length = totalEvaNum

	const totalEvaNum = detailData?.Judge?.length;
	const evaluatedNum = detailData?.Judge?.filter((j) => j?.Score?.length > 0).length;

	// 여기 안에 Argument 로 detailData.status 가 들어간다.
	// 그러면 현재 status 가 return 된다.
	// 진행 상태 페이지 조절 - '승인대기' , '승인', '완료', '반려'
	// const curStatus = currentStatus('승인');

	useEffect(() => {
		detailRequest.singleCall(param.idx, "path");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		switch (detailRequest.state) {
			case API_STATE.done:
				setCurStatus(currentStatus(detailRequest.response?.data?.status));
				setDetailData(detailRequest.response?.data);
				break;
			case API_STATE.error:
				navigate("/");
				console.log("error", detailRequest.error);
				alert(t("pages.investment.InvestEvalPage.evalRequest.request.alert"));
				break;
			default:
				break;
		}
	}, [detailRequest.state, detailRequest.response, detailRequest.error]);

	return (
		<>
			<Helmet>
				<title>
					{getTitle(
						`${t("pages.investment.InvestEvalPage.detail.index.title")}/${
							detailData.StartupCompany?.name ?? ""
						}`
					)}
				</title>
			</Helmet>
			<NavbarAndSidebarLayout menu={["invest", "evaluate"]} type={"main"}>
				<PageHeader />
				<div className="section-wrap">
					<section className="c__card process-step-wrap">
						<h5>{t("pages.investment.InvestEvalPage.evalRequest.request.title")}</h5>

						<ul className={`progress-step-bar ${curStatus}`}>
							<li className="step">
								<i>1</i>
								<p className="status">
									{t(
										"pages.investment.InvestEvalPage.evalRequest.request.status01"
									)}
								</p>
								<dl className="step-tooltip">
									<dt>
										{t(
											"pages.investment.InvestEvalPage.detail.index.section1.toolTip01"
										)}
									</dt>
									<dd>
										{moment(detailData.regDate).format("YYYY-MM-DD")}{" "}
										{t(
											"pages.investment.InvestEvalPage.evalRequest.request.status01"
										)}
									</dd>
								</dl>
							</li>
							<li className="step">
								<i>2</i>
								<p className="status">
									{t(
										"pages.investment.InvestEvalPage.detail.index.section1.status02"
									)}
								</p>
								<dl className="step-tooltip">
									<dt>
										{curStatus === "rejection"
											? t(
													"pages.investment.InvestEvalPage.detail.index.section1.curStatus01"
											  )
											: `${t(
													"pages.investment.InvestEvalPage.detail.index.section1.curStatus02"
											  )} ${evaluatedNum} / ${totalEvaNum}`}
									</dt>
									<dd>
										{" "}
										{curStatus === "rejection"
											? `${moment(detailData.confirmDate).format(
													"YYYY-MM-DD"
											  )} ${t(
													"pages.investment.InvestEvalPage.detail.index.section1.curStatus01"
											  )}`
											: `${moment(detailData.confirmDate).format(
													"YYYY-MM-DD"
											  )} ${t(
													"pages.investment.InvestEvalPage.detail.index.section1.curStatus03"
											  )}`}
									</dd>
								</dl>
							</li>
							<li className="step">
								<i>3</i>
								<p className="status">
									{t(
										"pages.investment.InvestEvalPage.detail.index.section1.status03"
									)}
								</p>
								<dl className="step-tooltip">
									<dt>
										{t(
											"pages.investment.InvestEvalPage.detail.index.section1.status03"
										)}
									</dt>
									<dd>
										{moment(detailData.confirmDate).format("YYYY-MM-DD")}{" "}
										{t(
											"pages.investment.InvestEvalPage.detail.index.section1.status03"
										)}
									</dd>
								</dl>
							</li>
						</ul>
					</section>

					<div
						className={`c__cardRow wrap-card card-${
							curStatus === "waiting" ? "step1" : moveCard
						}`}
					>
						<If condition={currentStep} {...{ detailData, company }}>
							<Case condition="closed">
								<RequestClosed {...{ setEvaluateCategoryModal, setCurrentStep }} />
							</Case>
							<Case condition="opened">
								<RequestOpened {...{ setEvaluateCategoryModal, setCurrentStep }} />
							</Case>
						</If>

						{/*------------하단 카드------------*/}
						<If condition={curStatus} {...{ detailData, navigate }}>
							<Case condition="evaluate">
								{/*-----심사*/}
								{/* <Judge {...{setOnlineIrModal, setResultAnnounceModal, setCommentaryModal}}/> */}
								<Judge {...{ param, detailRequest }} />
							</Case>
							<Case condition="complete">
								{/*-----완료*/}
								<Complete {...{ company }} />
							</Case>
							<Case condition="rejection">
								{/*-----반려*/}
								<Return />
							</Case>
						</If>
					</div>

					<div className="tab-footer">
						{curStatus !== "waiting" && (
							<>
								<button
									className="prev-btn"
									disabled={moveCard === "step1"}
									onClick={() => setMoveCard("step1")}
								>
									<RoundArrowIcon />
									<span>
										{t(
											"pages.investment.InvestEvalPage.detail.index.section1.prev"
										)}
									</span>
								</button>
								<button
									className="next-btn"
									disabled={moveCard === "step2"}
									onClick={() => setMoveCard("step2")}
								>
									<span>
										{t(
											"pages.investment.InvestEvalPage.detail.index.section1.next"
										)}
									</span>
									<RoundArrowIcon />
								</button>
							</>
						)}
					</div>

					<EvalItemCheck
						{...{ setEvaluateCategoryModal, evaluateCategoryModal, detailData }}
					/>

					<AlertDetail
						{...{
							commentaryModal,
							setCommentaryModal,
							onlineIrModal,
							setOnlineIrModal,
							resultAnnounceModal,
							setResultAnnounceModal,
							resultAnnounceChkAlert,
							setResultAnnounceChkAlert,
							resultAnnounceAlert,
							setResultAnnounceAlert,
							noResultAnnounceAlert,
							setNoResultAnnounceAlert,
						}}
					/>
				</div>
			</NavbarAndSidebarLayout>
		</>
	);
};

export default EvaluateDetailPage;
